import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateSubmittedV1DataSchema } from "./estimate-review-shared";

export const SowChangeSupplementEstimateReviewTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_SUPPLEMENT_ESTIMATE_REVIEW),
  data: z.discriminatedUnion("version", [EstimateSubmittedV1DataSchema]),
});
